import React from "react"
import PropTypes from "prop-types"

import { partialStoryShape } from "app/lib/shared_prop_types"
import loadHeroImage from "shared/lib/load_hero_image"
import logIFTTTNextAction from "app/lib/ifttt_next_log_action"

class StoryCard extends React.Component {
  handleOnClick = () => {
    logIFTTTNextAction("click", {
      location_type: "discover",
      object_id: this.props.story.id,
      object_type: "story",
      position: this.props.position,
      slug: this.props.story.slug,
    })
  }

  render() {
    return (
      <a
        className="story-box"
        title={this.props.story.title}
        aria-label={this.props.story.title}
        style={{
          background: `linear-gradient(to bottom, rgba(255, 255, 255, 0), rgba(0,0,0,0) 66%, rgba(0, 0, 0, 0.6)), url(${loadHeroImage(
            this.props.story.hero_image
          )})`,
          backgroundSize: "auto 23em",
          backgroundPosition: "bottom center",
          backgroundColor: `${this.props.story.hero_image["background_color"]}`,
        }}
        ref={el => {
          this.scrollObserverEl = el
        }}
        href={`/${this.props.singleStoryBasePath}/${this.props.story.slug}`}
        onClick={this.handleOnClick}
      >
        <div className="title">
          <h2>{this.props.story.title}</h2>
        </div>
      </a>
    )
  }
}

StoryCard.propTypes = {
  story: partialStoryShape.isRequired,
  position: PropTypes.number.isRequired,
  singleStoryBasePath: PropTypes.string.isRequired,
}

export default StoryCard
